import { css } from '@emotion/react';
import type { ReactNode } from 'react';
import type { Theme } from '~/_shared/themes/theme.model';
import type { ReportTableHeaderCell } from '~/exportReport/table/ReportTable.model';

const tableHeaderSpacerStyle = css({
  height: 5,
});

const tableHeaderCellStyle = (theme: Theme) => css({
  background: theme.reportColors.sectionBackground,
  color: theme.reportColors.textPrimary,
  border: `0 solid ${theme.reportColors.borderPrimary}`,
  padding: 5,
  textAlign: 'right',
  borderWidth: '1px 0',
  boxShadow: `${theme.reportColors.boxShadow} 0 1px 0`,
  position: 'relative',
  '&:first-of-type': {
    borderRadius: '8px 0 0 8px',
    borderLeftWidth: 1,
    textAlign: 'left',
  },
  '&:last-of-type': {
    borderRadius: '0 8px 8px 0',
    borderRightWidth: 1,
  },
});

const tableHeaderCellWithDataStyle = css({
  minWidth: 120,
});

type ExportReportTableHeaderProps = Readonly<{
  label?: ReactNode;
  columnNames: ReadonlyArray<ReportTableHeaderCell>;
}>;

export const ExportReportTableHeaderComponent = (props: ExportReportTableHeaderProps) => {
  return (
    <thead>
      <tr>
        <td css={tableHeaderCellStyle}>{props.label}</td>
        {props.columnNames.map((columnName, index) => (
          <td css={[tableHeaderCellStyle, tableHeaderCellWithDataStyle]} key={index}>
            <div><strong>{columnName.heading}</strong></div>
            {columnName.secondaryHeading}
          </td>
        ))}
      </tr>
      <tr>
        <td colSpan={props.columnNames.length + 1} css={tableHeaderSpacerStyle} />
      </tr>
    </thead>
  );
};
